import { SUM } from '__jsLibs/EXCEL';
const gettersMonthlyCashflow = {
	MonthlyRevenues(state, getters) {
		return +getters.TotalRevenues;
	},
	OperatingExpenses2(state, getters) {
		return -getters.TotalOperatingExpensesCosts;
	},
	FinancingExpenses(state, getters) {
		return -getters.MonthlyPaymentWPMI;
	},
	MonthlyCashflow(state, getters) {
		return SUM([
			getters.MonthlyRevenues,
			getters.OperatingExpenses2,
			getters.FinancingExpenses
		]);
	}
};

export {
	gettersMonthlyCashflow
};
